import { endOfDay } from 'date-fns';
import parseISO from 'date-fns/parseISO';

export const DEFAULT_MIN_DATE = parseISO('1900-01-01');
export const DEFAULT_MAX_DATE = endOfDay(new Date());
